export const registerSheddingHandling = (vue) => {
    vue.$api.errorCallbacks.onSheddingError = () => {
        vue.$store.commit('SET_PUBLIC_PAGE_BLOCKED', true);
    };
};
